export default __webpack_public_path__ + "static/media/office-profile.becdbfc6.svg";